import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { RecordTimelogModel } from '@smarttask-common/src/lib/models/TimeTracking/Timelog/RecordTimelogModel';

export enum TimelogActionTypes {
    ADD_TIMELOG = '[Timelog] Create Timelog',
    ADD_TIMELOGS = '[Timelog] Add Timelogs',
    UPSERT_TIMELOG = '[Timelog] Upsert Timelog',
    UPSERT_TIMELOGS = '[Timelog] Upsert Timelogs',
    UPDATE_TIMELOG = '[Timelog] Update Timelog',
    UPDATE_TIMELOGS = '[Timelog] Update Timelogs',
    DELETE_TIMELOG = '[Timelog] Delete Timelog',
    DELETE_TIMELOGS = '[Timelog] Delete Timelogs',
    DELETE_ALL_TIMELOGS = '[Timelog] Delete All Timelogs',
    DELETE_ALL = '[Timelog] Delete All',

    UPDATE_SELECTED_ID = '[Timelog] Update SelectedId',
}

export class UpdateSelectedTimelogId implements Action {
    readonly type = TimelogActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_timelog_id: string) {}
}

export class AddOne implements Action {
    readonly type = TimelogActionTypes.ADD_TIMELOG;
    constructor(public timelog: RecordTimelogModel) {}
}

export class AddMany implements Action {
    readonly type = TimelogActionTypes.ADD_TIMELOGS;
    constructor(public timelogs: Array<RecordTimelogModel>) {}
}

export class UpsertOne implements Action {
    readonly type = TimelogActionTypes.UPSERT_TIMELOG;

    constructor(public timelog: RecordTimelogModel) {}
}

export class UpsertMany implements Action {
    readonly type = TimelogActionTypes.UPSERT_TIMELOGS;
    constructor(public timelogs: Array<RecordTimelogModel>) {}
}

export class UpdateOne implements Action {
    readonly type = TimelogActionTypes.UPDATE_TIMELOG;
    constructor(public timelog: Update<RecordTimelogModel>) {}
}

export class UpdateMany implements Action {
    readonly type = TimelogActionTypes.UPDATE_TIMELOGS;
    constructor(public timelogs: Array<Update<RecordTimelogModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = TimelogActionTypes.DELETE_TIMELOG;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = TimelogActionTypes.DELETE_TIMELOGS;
    constructor(public ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = TimelogActionTypes.DELETE_ALL_TIMELOGS;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = TimelogActionTypes.DELETE_ALL;
    constructor() {}
}

export type TimelogActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedTimelogId;
